export default __webpack_public_path__ + "static/media/CLICHY (157 sur 176).1dbd0d12.jpg";